import { createContext } from "react";

const AdministrativeDaysContext = createContext();

export default AdministrativeDaysContext;
